"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGGED_RESELLER_COOKIE_KEY = exports.CHECKOUT_CUSTOMER_ID_COOKIE_EXPIRES_AT = exports.CHECKOUT_CUSTOMER_ID_COOKIE_KEY = exports.CONSUMER_AREA_LOGGED_USER_COOKIE_KEY = void 0;
exports.CONSUMER_AREA_LOGGED_USER_COOKIE_KEY = 'token';
exports.CHECKOUT_CUSTOMER_ID_COOKIE_KEY = 'CHECKOUT_CF_ID';
exports.CHECKOUT_CUSTOMER_ID_COOKIE_EXPIRES_AT = 120 * 24 * 60 * 60 * 1000;
exports.LOGGED_RESELLER_COOKIE_KEY = 'userToken';
